// eslint-disable-next-line
import React, { useState, useEffect } from "react";

// eslint-disable-next-line
import {
  Link,
  NavLink,
  Route,
  Routes,
  useParams,
  useNavigate,
} from "react-router-dom";

import { auth, firebase } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import axios from "axios";
import "./App.css";
import logo3 from "./assets/icon.png";
import { connectStorageEmulator } from "@firebase/storage";

function NavBar({
  viewparentpage,
  setViewparentpage,
  donotshow,
  aboutHasBulletinEntries,
  role,
  temparray,
  selectedclass,
  setSelectedclass,
  activeid,
  sections,
  activename,
  bringinmenu2,
  noclasschangeandmainmenuonly,
  parentlanguagecode,
  userState,
  setUserState,
  currentpage,
  id2, personaldata, setShowgrades, showgrades, objectofclass, setCurrentstudent, setShowcurrentroster, setStudentidd, setActiveid,
  setActivestudentlist,
  setActivename,
  setActiveperiod, setShowbirthday }) {
  const [click, setClick] = React.useState(false);
  const [bringinmenu, setBringinmenu] = useState(false);
  const navigate = useNavigate();

  const [text0, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [hasAboutBulletinEntries, setHasAboutBulletinEntries] = useState(false);

  const [usethisarray, setUsethisarray] = useState();

  // eslint-disable-next-ine
  const { only2studentid, studentid, classid, language, id, classidd } =
    useParams();

  const readStoredAboutEntries = () => {
    if (typeof aboutHasBulletinEntries === "boolean") {
      return aboutHasBulletinEntries;
    }

    if (Array.isArray(objectofclass?.bulletinarray)) {
      return objectofclass.bulletinarray.length > 0;
    }

    try {
      const storedAboutObject = localStorage.getItem("aboutobjectofclass");
      if (storedAboutObject) {
        const parsedAboutObject = JSON.parse(storedAboutObject);
        if (Array.isArray(parsedAboutObject?.bulletinarray)) {
          return parsedAboutObject.bulletinarray.length > 0;
        }
      }
    } catch (error) {
      console.warn("Failed to read aboutobjectofclass from localStorage:", error);
    }

    try {
      const storedBulletinArray = localStorage.getItem("bulletinarray");
      if (storedBulletinArray) {
        const parsedBulletinArray = JSON.parse(storedBulletinArray);
        if (Array.isArray(parsedBulletinArray)) {
          return parsedBulletinArray.length > 0;
        }
      }
    } catch (error) {
      console.warn("Failed to read bulletinarray from localStorage:", error);
    }

    return null;
  };

  useEffect(() => {
    const storedValue = readStoredAboutEntries();
    if (typeof storedValue === "boolean") {
      setHasAboutBulletinEntries(storedValue);
    }
  }, [aboutHasBulletinEntries, objectofclass, id, studentid, only2studentid]);

  useEffect(() => {
    let isCancelled = false;

    if (!id) {
      return undefined;
    }

    const loadAboutVisibility = async () => {
      try {
        const docSnap = await getDoc(doc(firebase, "users", id));

        if (isCancelled) {
          return;
        }

        const teacherData = docSnap.data() || {};
        const nextValue = Array.isArray(teacherData.bulletinarray)
          ? teacherData.bulletinarray.length > 0
          : false;

        setHasAboutBulletinEntries(nextValue);
      } catch (error) {
        if (!isCancelled) {
          console.warn("Failed to load bulletinarray visibility for Navbar:", error);
        }
      }
    };

    loadAboutVisibility();

    return () => {
      isCancelled = true;
    };
  }, [id, studentid, only2studentid]);



  useEffect(() => {
    if (language !== "en") {
      console.log(language, "this is the language in navbar");
      headingtranslater();
      headingtranslater2();
      headingtranslater3();
      headingtranslater4();
    }
  }, [language]);

  async function headingtranslater() {
    if (!language || language === "en") return;
    try {

      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Home",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText0(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  }


  async function restttt() {
    setSelectedclass("");
    if (typeof setShowbirthday === "function") {
      setShowbirthday(false);
    }
    setTimeout(() => {
      setShowgrades(false);
    }, 500);
  }


  async function headingtranslater2() {
    if (!language || language === "en") return;
    try {

      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "About",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText1(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async function headingtranslater3() {
    if (!language || language === "en") return;
    try {

      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Messages",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText2(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  }


  async function headingtranslater4() {
    if (!language || language === "en") return;
    try {

      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Grades",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText3(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  console.log(activename, "IN NAVBAR");

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  console.log(temparray, "this is temparray ")

  useEffect(() => {
    if (typeof bringinmenu2 != "undefined") {
      setBringinmenu(bringinmenu2);
    }
  }, [bringinmenu2]);


  useEffect(() => {
    if (typeof bringinmenu != "undefined") {
      console.log(bringinmenu, "this is bringinmenu in navbar", donotshow, " and this is donotshow", click, "this is the click", id, "this is the id", role, "this is the role", id2, "this is id2", "IN THE NAVBAR");
    }
  }, [bringinmenu, donotshow, id, role, id2]);

  useEffect(() => {
    if (typeof role != "undefined") {
      console.log(role, language, "this is the role from Navbar and language");
    }
  }, [role]);

  useEffect(() => {
    if (typeof temparray != "undefined") {
      console.log(temparray, "1this is what it issSSSS")
      let ore = JSON.stringify(temparray);
      console.log(ore, "2this is what it issSSSS");

      let test = JSON.parse(ore);
      console.log(test, "3this is what it issSSSS");
      setUsethisarray(test);
    }
  }, [temparray]);

  useEffect(() => {
    if (typeof showgrades != "undefined" && showgrades == false) {
      setSelectedclass("")
    }
  }, [showgrades]);



  const selected = async (something) => {
    setSelectedclass(something);
    if (typeof setShowbirthday === "function") {
      setShowbirthday(false);
    }

    console.log(something, "hIIIIII");

    // When a class is selected, navigate to the appropriate page
    // based on current page and preserve state
    if (currentpage === "AvailableClasses") {
      // Stay on the same page
    } else if (currentpage === "Mainmenu") {
      // Stay on the same page
    }
  };

  const selectsetup = async () => {
    setActiveid("123");
    setActivestudentlist([]);
    setActivename("");
    setActiveperiod("");
    setSelectedclass("");
  };

  const selected2 = async (something) => {
    setSelectedclass(something);
  };

  // Helper function to navigate with state preservation
  const navigateTo = (path) => {
    console.log(path, "navigating to this path");
    // Extract only the needed state values to avoid passing too much data)

    navigate(path, { state: { personaldata } });
  };

  // "id" means 'teacher id'

  const Homewithid = "/" + classid + "/id/" + id;
  const MainMenu = "/MainMenupage/id/" + id;
  // eslint-disable-next-line
  const Studentswithid = "/Students/id/" + id;
  // eslint-disable-next-line
  const Passeswithid = "/Passes/id/" + id;

  const Studenthome = "/role/Student/Mainmenustudents/id/" + id;

  //  ?Menu with all 3

  //Admin pages begin

  const Adminmainmenu = "/role/" + role + "/mainmenupage/id/" + id;
  // eslint-disable-next-line
  const Adminpassespage = "/role/" + role + "/passes/id/" + id;
  // eslint-disable-next-line
  const Adminsearch = "/role/" + role + "/search/id/" + id;
  const Adminhistoorical = "/role/" + role + "/historical/id/" + id;

  //Admin pages end

  const Homewithparentimports =
    "/studentid/" + studentid + "/" + classid + "/id/" + id + "/language/" + language;

  const Aboutwithparentimports =
    "/About/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const Messageswithparentimports =
    "/Messages/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const Classroomwithparentimports =
    "/Classroom/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  //  ?Menu with only 2

  const Homewithparentimports2 =
    "/only2studentid/" +
    only2studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const Aboutwithparentimports2 =
    "/About/only2studentid/" +
    only2studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const Messageswithparentimports2 =
    "/Messages/only2studentid/" +
    only2studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  //  ?Teacher View menu with all 3

  const viewHomewithparentimports =
    "/view/" + role + "/id/" +
    id +
    "/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const viewAboutwithparentimports =
    "/view/" + role + "/id/" +
    id +
    "/About/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const viewMessageswithparentimports =
    "/view/" + role + "/id/" +
    id +
    "/Messages/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const viewClassroomwithparentimports =
    "/view/" + role + "/id/" +
    id +
    "/Classroom/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  //  ?Teacher Edit menu with all 3

  const editHomewithparentimports =
    "/edit/" + role + "/id/" +
    id +
    "/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const editAboutwithparentimports =
    "/edit/" + role + "/id/" +
    id +
    "/About/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const editMessageswithparentimports =
    "/edit/" + role + "/id/" +
    id +
    "/Messages/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const editClassroomwithparentimports =
    "/edit/" + role + "/id/" +
    id +
    "/Classroom/studentid/" +
    studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  //  Teacher View with 2

  const viewHomewithparentimports2 =
    "/view/" + role + "/id/" +
    id +
    "/only2studentid/" +
    only2studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const viewAboutwithparentimports2 =
    "/view/" + role + "/id/" +
    id +
    "/About/only2studentid/" +
    only2studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const viewMessageswithparentimports2 =
    "/view/" + role + "/id/" +
    id +
    "/Messages/only2studentid/" +
    only2studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  // Teacher Edit with 2

  const editHomewithparentimports2 =
    "/edit/" + role + "/id/" +
    id +
    "/only2studentid/" +
    only2studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const editAboutwithparentimports2 =
    "/edit/" + role + "/id/" +
    id +
    "/About/only2studentid/" +
    only2studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const editMessageswithparentimports2 =
    "/edit/" + role + "/id/" +
    id +
    "/Messages/only2studentid/" +
    only2studentid +
    "/" + classid + "/id/" +
    id +
    "/language/" +
    language;

  const newidforteacher = "/role/Teacher/mainmenu/id/" + id;



  const newidforstudent1 = "/role/Student/id/" + id2 + "/Availableclasses";

  const newidforstudent2 = "/role/Student/id/" + id2 + "/Mainmenustudents";

  const navItems = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <>
      {typeof language == "undefined" ? (
        <>
          {typeof role != "undefined" && role == "Admin" ? (
            <>
              <div
                className={click ? "main-container" : ""}
                onClick={() => Close()}
              />

              <nav className="navbar" onClick={(e) => e.stopPropagation()}>
                <div className="nav-container">
                  <NavLink
                    className="nav-logo22"
                    onClick={() => setBringinmenu(!bringinmenu)}
                  >
                    <img src={logo3} className="App-logo3" alt="logo" />
                  </NavLink>

                  <ul className={click ? "nav-menu active" : "nav-menu"}>
                    {typeof sections != "undefined" &&
                      sections.map((item, index) => (
                        <React.Fragment key={index}>
                          {typeof activename == "undefined" ||
                            activename != item.Name ? (
                            <li className="nav-item">
                              <NavLink
                                onClick={() => setSelectedclass(item)}
                                activeclassname="active"
                                className="nav-links"
                              >
                                {item.Name}
                              </NavLink>
                            </li>
                          ) : null}
                        </React.Fragment>
                      ))}


                  </ul>
                </div>
              </nav>

              <div
                className={
                  bringinmenu
                    ? "App-logo4 nav-menu-ifsmall"
                    : "nav-menu-ifsmall5"
                }
              >
                <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                  <ul
                    className={"nav-menu3 active2"}
                    onClick={() => setBringinmenu(!bringinmenu)}
                  >
                    {typeof sections != "undefined" &&
                      sections.map((item, index) => (
                        <React.Fragment key={index}>
                          {typeof activename == "undefined" ||
                            activename != item.Name ? (
                            <li className="nav-item2">
                              <NavLink
                                onClick={() => setSelectedclass(item)}
                                activeclassname="active2"
                                className="nav-links2"
                              >
                                {item.Name}
                              </NavLink>
                            </li>
                          ) : null}
                        </React.Fragment>
                      ))}
                    <li className="nav-item2">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                      ></NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          ) : typeof role != "undefined" && role == "Student" ? (
            <>
              <div
                className={click ? "main-container" : ""}
                onClick={() => Close()}
              />

              <nav className="navbar" onClick={(e) => e.stopPropagation()}>
                <div className="nav-container" key="12348">
                  <NavLink
                    className="nav-logo22"
                    onClick={() => setBringinmenu(!bringinmenu)}
                    key="12347">
                    <img src={logo3} className="App-logo3" alt="logo" key="12346" />
                  </NavLink>

                  <ul className={click ? "nav-menu active" : "nav-menu"} key="12341">
                    <>
                      {typeof temparray != "undefined" && (
                        <>
                          {typeof activeid != "undefined" ? <li className="nav-item">
                            <NavLink
                              onClick={() =>
                                restttt()}
                              activeclassname="active"
                              className={"nav-links23"}
                            >
                              Reset
                            </NavLink>
                          </li> : null}
                          {temparray.map((item, index) => (
                            <React.Fragment key={item.key || index}>
                              {typeof activeid == "undefined" || activeid != item.key ? (
                                <li className="nav-item">
                                  <NavLink
                                    activeclassname="active"
                                    className={item.id != activeid ? "nav-links"
                                      : "nav-links5"}

                                    onClick={() => selected(item)}
                                  >
                                    {item.classname && item.classname.length > 13
                                      ? `${item.classname.substring(0, 13)}...`
                                      : item.classname}  {item.period}
                                  </NavLink>
                                </li>
                              ) : null}
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </>

                  </ul>
                </div>
              </nav>

              <div
                className={
                  bringinmenu
                    ? "App-logo4 nav-menu-ifsmall"
                    : "nav-menu-ifsmall5"
                }
              >
                <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                  <ul
                    className={"nav-menu3 active2"}
                    onClick={() => setBringinmenu(!bringinmenu)}
                  >
                    <>
                      {typeof activeid != "undefined" ? <li className="nav-item2">
                        <NavLink
                          activeclassname="active2"
                          className="nav-links2"
                          onClick={() => restttt()}
                        >
                          Reset
                        </NavLink>
                      </li> : null}
                      {typeof temparray != "undefined" && (
                        temparray.map((item, index) => (
                          <React.Fragment key={item.key || index}>
                            {typeof activeid == "undefined" ||
                              activeid != item.key ? (
                              <li className="nav-item2">
                                <NavLink
                                  activeclassname="active2"
                                  className="nav-links2"
                                  onClick={() => selected(item)}
                                >
                                  {item.classname && item.classname.length > 13
                                    ? `${item.classname.substring(0, 13)}...`
                                    : item.classname}  {item.period}
                                </NavLink>
                              </li>
                            ) : null}
                          </React.Fragment>
                        ))

                      )}
                    </>
                    <li className="nav-item2">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                      ></NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          ) : typeof role != "undefined" && role == "Teacher" ? (
            <>
              <div
                className={click ? "main-container" : ""}
                onClick={() => Close()}
              />

              <nav className="navbar" onClick={(e) => e.stopPropagation()}>
                <div className="nav-container" key="12348">
                  <NavLink
                    className="nav-logo22"
                    onClick={() => setBringinmenu(!bringinmenu)}
                    key="12347">
                    <img src={logo3} className="App-logo3" alt="logo" key="12346" />
                  </NavLink>

                  <ul className={click ? "nav-menu active" : "nav-menu"} key="12341">
                    {/* Hardcoded Set-Up NavLink */}

                    {noclasschangeandmainmenuonly == true ? (
                      <li className="nav-item" key="12345">
                        <NavLink
                          to={newidforteacher}
                          activeclassname="active"
                          className="nav-links"
                          onClick={click ? handleClick : null}
                          key="12342"
                          state={{ personaldata }}
                        >
                          Main Menu
                        </NavLink>
                      </li>
                    ) : (
                      typeof usethisarray != "undefined" &&
                      temparray.map((item, index) => (
                        <React.Fragment key={index}>
                          {typeof activeid == "undefined" ||
                            activeid != item.key ? (
                            <>
                              <li className="nav-item">
                                <NavLink
                                  onClick={() => selected(item)}
                                  activeclassname="active"
                                  className={
                                    item.classname != activename
                                      ? "nav-links"
                                      : "nav-links5"
                                  }
                                >
                                  {item.classname && item.classname.length > 13
                                    ? `${item.classname.substring(0, 13)}...`
                                    : item.classname}  {item.period}
                                </NavLink>
                              </li>
                            </>
                          ) : null}
                        </React.Fragment>
                      ))
                    )}
                    {typeof activeid != "undefined" && activeid.length > 3 && noclasschangeandmainmenuonly != true ? (<li className="nav-item" key="setup-link">
                      <NavLink
                        activeclassname="active"
                        className="nav-links"
                        onClick={() => selectsetup()}
                      >
                        Set-Up
                      </NavLink>
                    </li>) : null}
                  </ul>
                </div>
              </nav>

              <div
                className={
                  bringinmenu
                    ? "App-logo4 nav-menu-ifsmall"
                    : "nav-menu-ifsmall5"
                }
              >
                <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                  <ul
                    className={"nav-menu3 active2"}
                    onClick={() => setBringinmenu(!bringinmenu)}
                  >
                    {/* Hardcoded Set-Up NavLink for small layout */}

                    {noclasschangeandmainmenuonly == true ? (
                      <li className="nav-item2">
                        <NavLink
                          to={newidforteacher}
                          activeclassname="active2"
                          className="nav-links2"
                          onClick={click ? handleClick : null}
                        >
                          Main Menu
                        </NavLink>
                      </li>) : typeof usethisarray != "undefined" &&
                    temparray.map((item, index) => (
                      <React.Fragment key={item.key || index}>
                        {typeof activeid == "undefined" ||
                          activeid != item.key ? (
                          <>
                            <li className="nav-item2">
                              <NavLink
                                activeclassname="active2"
                                className="nav-links2"
                                onClick={() => selected(item)}
                              >
                                {item.classname && item.classname.length > 13
                                  ? `${item.classname.substring(0, 13)}...`
                                  : item.classname}  {item.period}
                              </NavLink>
                            </li>
                          </>
                        ) : null}
                      </React.Fragment>
                    ))}
                    {typeof activeid != "undefined" && activeid.length > 3 && noclasschangeandmainmenuonly != true ? (<li className="nav-item2" key="setup-link-small">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={() => selectsetup()}
                      >
                        Set-Up
                      </NavLink>
                    </li>) : null}
                    <li className="nav-item2">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                      ></NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          ) : (
            <>
              <div
                className={click ? "main-container" : ""}
                onClick={() => Close()}
              />

              <nav className="navbar" onClick={(e) => e.stopPropagation()}>
                <div className="nav-container">
                  <NavLink
                    className="nav-logo22"
                    onClick={() => setBringinmenu(!bringinmenu)}
                  >
                    <img src={logo3} className="App-logo3" alt="logo" />
                  </NavLink>

                  <ul className={click ? "nav-menu active" : "nav-menu"}>
                    <li className="nav-item">
                      <NavLink
                        to="/"
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to="/SignIn2"
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                        Sign In
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to="/Support"
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                        Support
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </nav>

              <div
                className={
                  bringinmenu
                    ? "App-logo4 nav-menu-ifsmall"
                    : "nav-menu-ifsmall5"
                }
              >
                <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                  <ul
                    className={"nav-menu3 active2"}
                    onClick={() => setBringinmenu(!bringinmenu)}
                  >
                    <li className="nav-item2">
                      <NavLink
                        to="/"
                        activeclassname="active2"
                        className="nav-links2"
                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="nav-item2">
                      <NavLink
                        to="/SignIn2"
                        activeclassname="active2"
                        className="nav-links2"
                      >
                        Sign In
                      </NavLink>
                    </li>
                    <li className="nav-item2">
                      <NavLink
                        to="/Support"
                        activeclassname="active2"
                        className="nav-links2"
                      >
                        Support
                      </NavLink>
                    </li>
                    <li className="nav-item2">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                      ></NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          )}
        </>
      ) : typeof language != "undefined" && language != "en" ? (
        <div>
          <div
            className={click ? "main-container" : ""}
            onClick={() => Close()}
          />
          <nav className="navbar" onClick={(e) => e.stopPropagation()}>
            <div className="nav-container">
              <NavLink
                className="nav-logo22"
                onClick={() => setBringinmenu(!bringinmenu)}
              >
                <img src={logo3} className="App-logo3" alt="logo" />
              </NavLink>
              {typeof id != "undefined" &&
                typeof only2studentid != "undefined" &&
                viewparentpage === true && role == "checker" ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  {donotshow ? null : (
                    <li className="nav-item" key="edit-icon">
                      <NavLink
                        activeclassname="active"
                        className="nav-links"
                        onClick={() => setViewparentpage(false)}
                      >
                        ✏️
                      </NavLink>
                    </li>
                  )}

                  <li className="nav-item" key="view-home">
                    <NavLink
                      to={viewHomewithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                        {text0}
                    </NavLink>
                  </li>
                    <li className="nav-item" key="view-about">
                      <NavLink
                        to={viewAboutwithparentimports2}
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                          {text1}
                      </NavLink>
                    </li>
                  
                  <li className="nav-item" key="view-messages">
                    <NavLink
                      to={viewMessageswithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                        {text2}
                    </NavLink>
                  </li>
                </ul>
              ) : typeof id != "undefined" &&
                typeof studentid != "undefined" &&
                viewparentpage === true && role == "checker" ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  {donotshow ? null : (
                    <li className="nav-item" key="edit-icon">
                      <NavLink
                        activeclassname="active"
                        className="nav-links"
                        onClick={() => setViewparentpage(false)}
                      >
                        ✏️
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item" key="view-home">
                    <NavLink
                      to={viewHomewithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                        {text0}
                    </NavLink>
                  </li>
                    <li className="nav-item" key="view-about">
                      <NavLink
                        to={viewAboutwithparentimports}
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                          {text1}
                      </NavLink>
                    </li>
                  <li className="nav-item" key="view-messages">
                    <NavLink
                      to={viewMessageswithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                        {text2}
                    </NavLink>
                  </li>
                  <li className="nav-item" key="view-classroom">
                    <NavLink
                      to={viewClassroomwithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                        {text3}
                    </NavLink>
                  </li>
                </ul>
              ) : typeof id != "undefined" &&
                typeof only2studentid != "undefined" && role == "checker" ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  {donotshow ? null : (
                    <li className="nav-item">
                      <NavLink
                        activeclassname="active"
                        className="nav-links"
                        onClick={() => setViewparentpage(true)}
                      >
                        🔍
                      </NavLink>
                    </li>
                  )}

                  <li className="nav-item">
                    <NavLink
                      to={editHomewithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                <li className="nav-item">
                    <NavLink
                      to={editAboutwithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      About
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={editMessageswithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                </ul>
              ) : typeof id != "undefined" &&
                typeof studentid != "undefined" && role == "checker" ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  {donotshow ? null : (
                    <li className="nav-item">
                      <NavLink
                        activeclassname="active"
                        className="nav-links"
                        onClick={() => setViewparentpage(true)}
                      >
                        🔍
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item">
                    <NavLink
                      to={editHomewithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                 <li className="nav-item">
                    <NavLink
                      to={editAboutwithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      About
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={editMessageswithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={editClassroomwithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                      Grades
                    </NavLink>
                  </li>
                </ul>
              ) : only2studentid ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  <li className="nav-item">
                    <NavLink
                      to={Homewithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      {text0}
                    </NavLink>
                  </li>
                  {hasAboutBulletinEntries ? (
                    <li className="nav-item">
                      <NavLink
                        to={Aboutwithparentimports2}
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                        {text1}
                      </NavLink>
                    </li>
                  ) : null}
                  <li className="nav-item">
                    <NavLink
                      to={Messageswithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      {text2}
                    </NavLink>
                  </li>
                </ul>
              ) : studentid ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  <li className="nav-item">
                    <NavLink
                      to={Homewithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      {text0}
                    </NavLink>
                  </li>
                  {hasAboutBulletinEntries ? (
                    <li className="nav-item">
                      <NavLink
                        to={Aboutwithparentimports}
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                        {text1}
                      </NavLink>
                    </li>
                  ) : null}
                  <li className="nav-item">
                    <NavLink
                      to={Messageswithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      {text2}
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={Classroomwithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                      {text3}
                    </NavLink>
                  </li>
                </ul>
              ) : null}
              <div className="nav-icon" onClick={handleClick}>
                <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
              </div>
            </div>
          </nav>

          <div
            className={
              bringinmenu ? "App-logo4 nav-menu-ifsmall" : "nav-menu-ifsmall5"
            }
          >
            {typeof id != "undefined" &&
              typeof only2studentid != "undefined" &&
              viewparentpage === true && role == "checker" ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  {donotshow ? null : (
                    <li className="nav-item2" key="edit-icon">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={() => setViewparentpage(false)}
                      >
                        ✏️
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item2" key="view-home">
                    <NavLink
                      to={viewHomewithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                        {text0}
                    </NavLink>
                  </li>
                    <li className="nav-item2" key="view-about">
                      <NavLink
                        to={viewAboutwithparentimports2}
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={click ? handleClick : null}
                      >
                          {text1}
                      </NavLink>
                    </li>
                  <li className="nav-item2" key="view-messages">
                    <NavLink
                      to={viewMessageswithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                        {text2}
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      activeclassname="active2"
                      className="nav-links2"
                    ></NavLink>
                  </li>
                </ul>{" "}
              </nav>
            ) : typeof id != "undefined" &&
              typeof studentid != "undefined" &&
              viewparentpage === true && role == "checker" ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  {donotshow ? null : (
                    <li className="nav-item2" key="edit-icon">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={() => setViewparentpage(false)}
                      >
                        ✏️
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item2" key="view-home">
                    <NavLink
                      to={viewHomewithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                        {text0}
                    </NavLink>
                  </li>
                    <li className="nav-item2" key="view-about">
                      <NavLink
                        to={viewAboutwithparentimports}
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={click ? handleClick : null}
                      >
                          {text1}
                      </NavLink>
                    </li>
                  <li className="nav-item2" key="view-messages">
                    <NavLink
                      to={viewMessageswithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                        {text2}
                    </NavLink>
                  </li>
                  <li className="nav-item2" key="view-classroom">
                    <NavLink
                      to={viewClassroomwithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                        {text3}
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      activeclassname="active2"
                      className="nav-links2"
                    ></NavLink>
                  </li>
                </ul>
              </nav>
            ) : typeof id != "undefined" &&
              typeof only2studentid != "undefined" && role == "checker" ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  {donotshow ? null : (
                    <li className="nav-item2">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={() => setViewparentpage(true)}
                      >
                        🔍
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item2">
                    <NavLink
                      to={editHomewithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                    <li className="nav-item2">
                      <NavLink
                        to={editAboutwithparentimports2}
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={click ? handleClick : null}
                    >
                      About
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      to={editMessageswithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                </ul>
              </nav>
            ) : typeof id != "undefined" &&
              typeof studentid != "undefined" && role == "checker" ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  {donotshow ? null : (
                    <li className="nav-item2">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={() => setViewparentpage(true)}
                      >
                        🔍
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item2">
                    <NavLink
                      to={editHomewithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                    <li className="nav-item2">
                      <NavLink
                        to={editAboutwithparentimports}
                        activeclassname="active"
                        className="nav-links2"
                        onClick={click ? handleClick : null}
                    >
                      About
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      to={editMessageswithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      to={editClassroomwithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                      Grades
                    </NavLink>
                  </li>
                </ul>
              </nav>
            ) : only2studentid ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  <li className="nav-item2">
                    <NavLink
                      to={Homewithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                    >
                      {text0}
                    </NavLink>
                  </li>
                  {hasAboutBulletinEntries ? (
                    <li className="nav-item2">
                      <NavLink
                        to={Aboutwithparentimports2}
                        activeclassname="active2"
                        className="nav-links2"
                      >
                        {text1}
                      </NavLink>
                    </li>
                  ) : null}
                  <li className="nav-item2">
                    <NavLink
                      to={Messageswithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                    >
                      {text2}
                    </NavLink>
                  </li>

                  <li className="nav-item2">
                    <NavLink
                      activeclassname="active2"
                      className="nav-links2"
                    ></NavLink>
                  </li>
                </ul>
              </nav>
            ) : studentid ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  <li className="nav-item2">
                    <NavLink
                      to={Homewithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                    >
                      {text0}
                    </NavLink>
                  </li>
                  {hasAboutBulletinEntries ? (
                    <li className="nav-item2">
                      <NavLink
                        to={Aboutwithparentimports}
                        activeclassname="active2"
                        className="nav-links2"
                      >
                        {text1}
                      </NavLink>
                    </li>
                  ) : null}
                  <li className="nav-item2">
                    <NavLink
                      to={Messageswithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                    >
                      {text2}
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      to={Classroomwithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      state={{ objectofclass }}
                    >
                      {text3}
                    </NavLink>
                  </li>

                  <li className="nav-item2">
                    <NavLink
                      activeclassname="active2"
                      className="nav-links2"
                    ></NavLink>
                  </li>
                </ul>
              </nav>
            ) : null}
          </div>
        </div>
      ) : (
        //English Speaking section. 
        <div>
          <div
            className={click ? "main-container" : ""}
            onClick={() => Close()}
          />
          <nav className="navbar" onClick={(e) => e.stopPropagation()}>
            <div className="nav-container">
              <NavLink
                className="nav-logo22"
                onClick={() => setBringinmenu(!bringinmenu)}
              >
                <img src={logo3} className="App-logo3" alt="logo" />
              </NavLink>
              {typeof id != "undefined" &&
                typeof only2studentid != "undefined" &&
                viewparentpage === true && role == "checker" ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  {donotshow ? null : (
                    <li className="nav-item" key="edit-icon">
                      <NavLink
                        activeclassname="active"
                        className="nav-links"
                        onClick={() => setViewparentpage(false)}
                      >
                        ✏️
                      </NavLink>
                    </li>
                  )}

                  <li className="nav-item" key="view-home">
                    <NavLink
                      to={viewHomewithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                    <li className="nav-item" key="view-about">
                      <NavLink
                        to={viewAboutwithparentimports2}
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                        About
                      </NavLink>
                    </li>
                  <li className="nav-item" key="view-messages">
                    <NavLink
                      to={viewMessageswithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                </ul>
              ) : typeof id != "undefined" &&
                typeof studentid != "undefined" &&
                viewparentpage === true && role == "checker" ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  {donotshow ? null : (
                    <li className="nav-item" key="edit-icon">
                      <NavLink
                        activeclassname="active"
                        className="nav-links"
                        onClick={() => setViewparentpage(false)}
                      >
                        ✏️
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item" key="view-home">
                    <NavLink
                      to={viewHomewithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                    <li className="nav-item" key="view-about">
                      <NavLink
                        to={viewAboutwithparentimports}
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                        About
                      </NavLink>
                    </li>
                  <li className="nav-item" key="view-messages">
                    <NavLink
                      to={viewMessageswithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                  <li className="nav-item" key="view-classroom">
                    <NavLink
                      to={viewClassroomwithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                      Grades
                    </NavLink>
                  </li>
                </ul>
              ) : typeof id != "undefined" &&
                typeof only2studentid != "undefined" && role == "checker" ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  {donotshow ? null : (
                    <li className="nav-item">
                      <NavLink
                        activeclassname="active"
                        className="nav-links"
                        onClick={() => setViewparentpage(true)}
                      >
                        🔍
                      </NavLink>
                    </li>
                  )}

                  <li className="nav-item">
                    <NavLink
                      to={editHomewithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                    <li className="nav-item">
                    <NavLink
                      to={editAboutwithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      About
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={editMessageswithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                </ul>
              ) : typeof id != "undefined" &&
                typeof studentid != "undefined" && role == "checker" ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  {donotshow ? null : (
                    <li className="nav-item">
                      <NavLink
                        activeclassname="active"
                        className="nav-links"
                        onClick={() => setViewparentpage(true)}
                      >
                        🔍
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item">
                    <NavLink
                      to={editHomewithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                    <li className="nav-item">
                      <NavLink
                        to={editAboutwithparentimports}
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                    >
                      About
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={editMessageswithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={editClassroomwithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                      Grades
                    </NavLink>
                  </li>
                </ul>
              ) : only2studentid ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  <li className="nav-item">
                    <NavLink
                      to={Homewithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                  {hasAboutBulletinEntries ? (
                    <li className="nav-item">
                      <NavLink
                        to={Aboutwithparentimports2}
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                        About
                      </NavLink>
                    </li>
                  ) : null}
                  <li className="nav-item">
                    <NavLink
                      to={Messageswithparentimports2}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                </ul>
              ) : studentid ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  <li className="nav-item">
                    <NavLink
                      to={Homewithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                  {hasAboutBulletinEntries ? (
                    <li className="nav-item">
                      <NavLink
                        to={Aboutwithparentimports}
                        activeclassname="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                      >
                        About
                      </NavLink>
                    </li>
                  ) : null}
                  <li className="nav-item">
                    <NavLink
                      to={Messageswithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={Classroomwithparentimports}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                      Grades
                    </NavLink>
                  </li>

                  <li className="nav-item">
                    <NavLink
                      activeclassname="active"
                      className="nav-links"
                    ></NavLink>
                  </li>
                </ul>
              ) : id ? (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  <li className="nav-item">
                    <NavLink
                      to={Homewithid}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={MainMenu}
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Main Menu
                    </NavLink>
                  </li>
                </ul>
              ) : (
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  <li className="nav-item">
                    <NavLink
                      to="/"
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/SignIn2"
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Sign In
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/Support"
                      activeclassname="active"
                      className="nav-links"
                      onClick={click ? handleClick : null}
                    >
                      Support
                    </NavLink>
                  </li>
                </ul>
              )}
              <div className="nav-icon" onClick={handleClick}>
                <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
              </div>
            </div>
          </nav>







          <div
            className={
              bringinmenu ? "App-logo4 nav-menu-ifsmall" : "nav-menu-ifsmall5"
            }
          >
            {typeof id != "undefined" &&
              typeof only2studentid != "undefined" &&
              viewparentpage === true && role == "checker" ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  {donotshow ? null : (
                    <li className="nav-item2" key="edit-icon">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={() => setViewparentpage(false)}
                      >
                        ✏️
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item2" key="view-home">
                    <NavLink
                      to={viewHomewithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                    <li className="nav-item2" key="view-about">
                      <NavLink
                        to={viewAboutwithparentimports2}
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={click ? handleClick : null}
                      >
                        About
                      </NavLink>
                    </li>
                  <li className="nav-item2" key="view-messages">
                    <NavLink
                      to={viewMessageswithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      activeclassname="active2"
                      className="nav-links2"
                    ></NavLink>
                  </li>
                </ul>{" "}
              </nav>
            ) : typeof id != "undefined" &&
              typeof studentid != "undefined" &&
              viewparentpage === true && role == "checker" ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  {donotshow ? null : (
                    <li className="nav-item2" key="edit-icon">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={() => setViewparentpage(false)}
                      >
                        ✏️
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item2" key="view-home">
                    <NavLink
                      to={viewHomewithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                    <li className="nav-item2" key="view-about">
                      <NavLink
                        to={viewAboutwithparentimports}
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={click ? handleClick : null}
                      >
                        About
                      </NavLink>
                    </li>
                  <li className="nav-item2" key="view-messages">
                    <NavLink
                      to={viewMessageswithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                  <li className="nav-item2" key="view-classroom">
                    <NavLink
                      to={viewClassroomwithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                      Grades
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      activeclassname="active2"
                      className="nav-links2"
                    ></NavLink>
                  </li>
                </ul>
              </nav>
            ) : typeof id != "undefined" &&
              typeof only2studentid != "undefined" && role == "checker" ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  {donotshow ? null : (
                    <li className="nav-item2">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={() => setViewparentpage(true)}
                      >
                        🔍
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item2">
                    <NavLink
                      to={editHomewithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                    <li className="nav-item2">
                      <NavLink
                        to={editAboutwithparentimports2}
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={click ? handleClick : null}
                    >
                      About
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      to={editMessageswithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                </ul>
              </nav>
            ) : typeof id != "undefined" &&
              typeof studentid != "undefined" && role == "checker" ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  {donotshow ? null : (
                    <li className="nav-item2">
                      <NavLink
                        activeclassname="active2"
                        className="nav-links2"
                        onClick={() => setViewparentpage(true)}
                      >
                        🔍
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item2">
                    <NavLink
                      to={editHomewithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Home
                    </NavLink>
                  </li>
                <li className="nav-item2">
                    <NavLink
                      to={editAboutwithparentimports}
                      activeclassname="active"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      About
                    </NavLink>
                  </li> 
                  <li className="nav-item2">
                    <NavLink
                      to={editMessageswithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                    >
                      Messaging
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      to={editClassroomwithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      onClick={click ? handleClick : null}
                      state={{ objectofclass }}
                    >
                      Grades
                    </NavLink>
                  </li>
                </ul>
              </nav>
            ) : only2studentid ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  <li className="nav-item2">
                    <NavLink
                      to={Homewithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                    >
                      Home
                    </NavLink>
                  </li>
                  {hasAboutBulletinEntries ? (
                    <li className="nav-item2">
                      <NavLink
                        to={Aboutwithparentimports2}
                        activeclassname="active2"
                        className="nav-links2"
                      >
                        About
                      </NavLink>
                    </li>
                  ) : null}
                  <li className="nav-item2">
                    <NavLink
                      to={Messageswithparentimports2}
                      activeclassname="active2"
                      className="nav-links2"
                    >
                      Messaging
                    </NavLink>
                  </li>

                  <li className="nav-item2">
                    <NavLink
                      activeclassname="active2"
                      className="nav-links2"
                    ></NavLink>
                  </li>
                </ul>
              </nav>
            ) : studentid ? (
              <nav className="navbar2" onClick={(e) => e.stopPropagation()}>
                <ul
                  className={"nav-menu3 active2"}
                  onClick={() => setBringinmenu(!bringinmenu)}
                >
                  <li className="nav-item2">
                    <NavLink
                      to={Homewithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                    >
                      Home
                    </NavLink>
                  </li>
                  {hasAboutBulletinEntries ? (
                    <li className="nav-item2">
                      <NavLink
                        to={Aboutwithparentimports}
                        activeclassname="active2"
                        className="nav-links2"
                      >
                        About
                      </NavLink>
                    </li>
                  ) : null}
                  <li className="nav-item2">
                    <NavLink
                      to={Messageswithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                    >
                      Messaging
                    </NavLink>
                  </li>
                  <li className="nav-item2">
                    <NavLink
                      to={Classroomwithparentimports}
                      activeclassname="active2"
                      className="nav-links2"
                      state={{ objectofclass }}
                    >
                      Grades
                    </NavLink>
                  </li>

                  <li className="nav-item2">
                    <NavLink
                      activeclassname="active2"
                      className="nav-links2"
                    ></NavLink>
                  </li>
                </ul>
              </nav>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
}

export default NavBar;